interface Forward10IconProps {
    className?: string;
    color?: string;
    size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const Forward10Icon = ({
                                  className = "",
                                  color = "currentColor",
                                  size = "md",
                              }: Forward10IconProps) => {
    const sizeClasses = {
        base: "w-6 h-6", // 24x24px
        xs: "w-7 h-7",
        sm: "w-8 h-8",
        md: "w-9 h-9",
        lg: "w-11 h-11",
        xl: "w-13 h-13",
    };

    return (
        <div className="icon forward-10-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                {/* `1` number */}
                <path
                    d="M8.84,16.66v-7.15s0-.04-.03-.04c-.01,0-.03,0-.03.01,0,0-1.27,1.47-1.91,1.89"
                    fill="none"
                    stroke={color}
                    strokeWidth={1.25}
                    strokeMiterlimit={50}
                    strokeLinecap="round"
                />

                {/* `0` number */}
                <rect
                    x="12.28"
                    y="9.47"
                    width="4.01"
                    height="7.2"
                    rx="2.01"
                    ry="2.01"
                    fill="none"
                    stroke={color}
                    strokeWidth={1.25}
                    strokeMiterlimit={50}
                />

                {/* Arrow tip */}
                <polyline
                    points="8.98 1.36 12.05 3.45 9.74 6.33"
                    fill="none"
                    stroke={color}
                    strokeWidth={1.5}
                    strokeMiterlimit={50}
                    strokeLinecap="round"
                />

                {/* Arrow body */}
                <path
                    d="M11.72,3.47c-5.29.15-9.46,4.57-9.3,9.86.15,5.29,4.57,9.46,9.86,9.3,5.29-.15,9.46-4.57,9.3-9.86-.09-3.11-1.68-5.98-4.27-7.7"
                    fill="none"
                    stroke={color}
                    strokeWidth={1.4}
                    strokeMiterlimit={50}
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
};

export default Forward10Icon;